var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBridgesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.987 2.15-.039-.054-.05-.07a5.428 5.428 0 0 0-.44-.505 5.428 5.428 0 0 0-.506-.441l-.069-.05-.05-.039A5.15 5.15 0 0 0 14.777 0c-1.389 0-2.699.54-3.68 1.526l-.899.898L9.02 3.602 6.526 6.095A5.18 5.18 0 0 0 5 9.776c0 1.39.54 2.7 1.526 3.681a5.167 5.167 0 0 0 3.681 1.522c1.394 0 2.7-.54 3.681-1.522l4.57-4.569a5.18 5.18 0 0 0 1.526-3.68 5.21 5.21 0 0 0-.997-3.058zM17.3 7.73l-4.57 4.569a3.556 3.556 0 0 1-2.522 1.045c-.913 0-1.83-.348-2.522-1.045a3.558 3.558 0 0 1-1.046-2.523c0-.952.373-1.85 1.046-2.522l2.493-2.493 1.178-1.178.898-.898a3.572 3.572 0 0 1 4.402-.51 3.443 3.443 0 0 1 .648.51c.172.171.329.363.461.569.015.024.035.049.05.078.348.565.534 1.213.534 1.88A3.572 3.572 0 0 1 17.3 7.73z",
    fill: "#00E1D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.987 9.15-.039-.054-.05-.07a5.428 5.428 0 0 0-.44-.505 5.428 5.428 0 0 0-.506-.441l-.069-.05-.05-.039A5.15 5.15 0 0 0 11.777 7c-1.389 0-2.699.54-3.68 1.526l-.899.898-1.178 1.178-2.493 2.493A5.18 5.18 0 0 0 2 16.776c0 1.39.54 2.7 1.526 3.681a5.167 5.167 0 0 0 3.681 1.522c1.394 0 2.7-.54 3.681-1.522l4.57-4.569a5.18 5.18 0 0 0 1.526-3.68 5.21 5.21 0 0 0-.997-3.058zM14.3 14.73l-4.57 4.569a3.556 3.556 0 0 1-2.522 1.045c-.913 0-1.83-.348-2.522-1.045a3.558 3.558 0 0 1-1.046-2.523c0-.952.373-1.85 1.046-2.522l2.493-2.493 1.178-1.178.898-.898a3.572 3.572 0 0 1 4.402-.51 3.443 3.443 0 0 1 .648.51c.172.171.329.363.461.569.015.024.035.049.05.078.348.565.534 1.213.534 1.88a3.572 3.572 0 0 1-1.05 2.518z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBridgesActive);
export default __webpack_public_path__ + "static/media/icon-bridges-active.0c6409fe3945d3e7651d28abe7b1bf02.svg";
export { ForwardRef as ReactComponent };